import ReactDOM from 'react-dom';
import _ from 'lodash';

import { KeyCodes } from '../../constants/AppConstants';
import PureRenderComponent from '../PureRenderComponent';

/**
 * Base component for components that contain forms to extend
 *
 * Replaces the focusOnError mixin
 */

class FormComponent extends PureRenderComponent {

    state = {
        submitted: false
    };

    componentDidUpdate (prevProps, prevState) {
        if (this._shouldFocus(prevProps, prevState)) {
            _.defer(this._focusOnError);
        }
    }

    _shouldFocus (prevProps, prevState) {
        return !prevState.submitted && this.state.submitted;
    }

    _handlerForEnter = (callback) => (event) => {
        if (event.keyCode === KeyCodes.ENTER) {
            _.defer(callback);
        }
    };

    captureFormRef = formRef => {
        this._formRef = formRef;
    };

    _focusOnError = () => {
        const form = this.refs.form || this._formRef;
        if (!form) {
            console.warn('Form ref not set, so cannot focus on errors. Use `ref={ this.captureFormRef }`');
        }
        const node = ReactDOM.findDOMNode(form);
        if (node) {
            const errors = node.querySelectorAll('.input--invalid, .checkbox--invalid, .alert-warning, .alert-danger');

            if (errors.length !== 0) {
                errors[0].focus();
                errors[0].scrollIntoView();
            }
        }
    };

}

export default FormComponent;
